import { ListingCard } from "./components/listing-card";
import { Sun } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { WithErrorAndLoading } from "@/components/with-error-and-loading";
import { useListings } from "@/hooks/use-listings";
import { SEO } from "@/components/seo";
import { NotFoundIcon } from "@/components/notfound";
import DualStakeHero from "./components/ds-hero";
import { Link } from "@/components/links";

export function DualStakeSunset() {
  const navigate = useNavigate();
  const {
    isLoading: loading,
    error: error,
    data: listings,
    refetch: refetch,
  } = useListings(undefined, true);

  const retry = () => {
    if (error) refetch();
  };

  const sortedListings = listings ? [...listings.values()] : [];

  return (
    <>
      <SEO
        type="product"
        title="Myth Finance dualSTAKE: Sunset tokens"
        description="Algorand Liquid Staking. Rewards in your favorite assets."
      />
      <WithErrorAndLoading
        loading={loading}
        error={error?.message}
        retry={retry}
      >
        <>
          <div className="flex flex-col items-center mb-4">
            <DualStakeHero />
            <div className="mt-4 -mb-3 flex flex-col md:flex-row gap-4 items-center w-full justify-between text-muted-foreground">
              <span>Showing <Link to="https://docs.myth.finance/dualSTAKE/sunsetting" className="text-foreground">Sunset</Link> tokens</span>
              <Button
                variant="secondary"
                onClick={() => navigate("/dualSTAKE")}
              >
                <Sun />
                Show Active Tokens
              </Button>
            </div>
          </div>

          <div className="container flex flex-wrap justify-center items-center gap-4">
            {sortedListings.map((li, i) => (
              <ListingCard listing={li} key={`li-${i}`} />
            ))}
            {listings?.size && !sortedListings.length ? (
              <div className="flex  mt-12 text-lg flex-col items-center">
                <NotFoundIcon className="mb-8 text-muted-foreground" />
                <div className="text-muted-foreground">Nothing to show.</div>
                <div className="flex items-center gap-1">
                  Check your filter preferences.{" "}
                </div>
              </div>
            ) : null}
          </div>
          <div className="flex-grow"></div>
        </>
      </WithErrorAndLoading>
    </>
  );
}
